<div class="dropdown">
    <div ngbDropdown container="body" [class.disabled]="true" aria-disabled="true" [placement]="['top-end', 'bottom-end']">
        <div ngbDropdownToggle class="cursor-pointer">
            <span>{{ column.header | translate }} </span>
            <span class="filtered-by"> ( {{ filteredByAsString | translate }} ) </span>
            <span class="material-symbols-outlined filter-dropdown-icon cursor-pointer"> expand_more </span>
        </div>
        <div ngbDropdownMenu>
            <div class="filter-dropdown-list list-wrapper">
                <li *ngFor="let item of list">
                    <mat-checkbox
                        [checked]="item.checked"
                        [value]="item.name"
                        (change)="onChange($event, item)"
                        [disabled]="item.id === 0 && allOptionDisabled"
                    >
                        {{ item.name | translate }}</mat-checkbox
                    >
                </li>
            </div>

            <div class="actions-container">
                <button ngbDropdownItem class="btn btn-reset" *ngIf="list?.length !== 0 && list !== undefined" (click)="onResetFilter()">
                    <span class="material-symbols-outlined">filter_alt_off</span>
                </button>
                <button ngbDropdownItem class="btn btn-coral" *ngIf="list?.length !== 0 && list !== undefined" (click)="onApplyFilter()">
                    {{ 'apply' | translate }}
                </button>
            </div>
            <div class="loader-container" *ngIf="list?.length === 0">
                <div class="small-loader loader">
                    <div class="loader-ring center-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
            <div *ngIf="list === undefined" class="empty-state">{{ 'noInformation' | translate }}</div>
        </div>
    </div>
</div>
